<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left-title">
        <h1 class="title is-3">
          <span class="">Statistiques de Rendez-vous</span>
        </h1>
      </div>
      <div class="column is-paddingless is-border-left" slot="left-action">
        <a @click="reloadRdvData"
           class="page-header-btn is-small"
        >
          <span class="icon is-small">
            <i class="fal fa-sync"></i>
          </span>
          <span>Actualiser</span>
        </a>
      </div>
      <div class="column is-paddingless is-border-left" slot="right-content">
        <a class="page-header-btn tooltip is-square is-tooltip-left is-tooltip-primary"
           :data-tooltip="fullscreen ? 'Réduire' : 'Agrandir'" @click="toggleFullscreen">
          <span class="icon">
            <i class="fal" :class="fullscreen ? 'fa-compress-wide' : 'fa-expand-wide'"></i>
          </span>
        </a>
      </div>
    </sticky>

    <div class="page-content is-padding-top">
      <div
        class="columns is-sticky-in-mainColumn is-zindex-8 is-gapless has-bg-white is-margin-left is-margin-right is-border">
        <div class="column is-10 is-8-widescreen">
          <stats-menu></stats-menu>
        </div>
        <div class="column"></div>
      </div>

      <div class="is-padding" data-sticky-pos-top="headerStats">
        <div class="has-bg-white is-border ">
          <div class="columns is-gapless">
            <div class="column is-3 is-border-right">
              <div class="field is-padding-left is-padding-right has-bg-lighter">
                <p class="control has-icons-left has-icons-right">
                  <flat-pickr id="startDatePicker" :config="periodConfigDate"
                              v-model="rawStartDate"
                              @on-change="updateStartDate"
                              @on-close="resetPeriod"
                              class="input is-fullwidth is-borderless has-bg-lighter"
                              name="date">
                  </flat-pickr>
                  <span class="icon is-small is-left has-text-black">
                    <i class="fal fa-calendar-alt is-size-4"></i>
                  </span>
                  <span class="icon is-large is-right has-text-dark">
                    <i class="far fa-chevron-down is-size-7"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-3 is-border-right">
              <div class="field is-padding-left is-padding-right has-bg-lighter">
                <p class="control has-icons-left has-icons-right">
                  <flat-pickr id="endDatePicker" :config="periodConfigDate"
                              v-model="rawEndDate"
                              @on-close="resetPeriod"
                              @on-change="updateEndDate"
                              class="input is-fullwidth is-borderless has-bg-lighter"
                              name="date">
                  </flat-pickr>
                  <span class="icon is-small is-left has-text-black">
                    <i class="fal fa-calendar-alt is-size-4"></i>
                  </span>
                  <span class="icon is-large is-right has-text-dark">
                    <i class="far fa-chevron-down is-size-7"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right">
              <div class="select is-fullwidth">
                <select id="period" @change="setCustomPeriod" v-model="period" class="is-borderless">
                  <option :value="null">Périodes</option>
                  <option v-for="period in periods" :value="period">{{period.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentTab === TAB_MODES.TABLE"
             class="is-border-top is-radius-top-left-large is-radius-top-right-large is-margin-top"
             id="tableaux">
          <div
            class="columns is-vcentered is-gapless is-border-right is-border-left is-border-bottom is-radius-top-left-large is-radius-top-right-large has-bg-light">
            <div class="column">
              <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns ">
                <a
                  class="button is-small is-white is-transform-none is-padding-left-small is-padding-right-small is-min-width-0 is-active">Vendeurs</a>
                <!-- <a
                  class="button is-small is-light is-invertedd is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
                  disabled="true">Custom</a> -->
              </div>
            </div>
            <!-- <div class="column is-narrow is-padding-small">
              <a class="has-text-grey is-size-6 is-uppercase" disabled="true" style="cursor: not-allowed;">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
                <span>Créer nouveau tableau</span>
              </a>
            </div> -->
            <div class="column is-narrow is-padding-small" v-if="orderedEntities && orderedEntities.length">
              <a class="has-text-grey is-size-6 is-uppercase" @click="cleanSelection">
                <span class="icon is-small"><i class="fal fa-trash"></i></span>
                <span>Supprimer la selection</span>
              </a>
            </div>
            <div class="column is-narrow is-padding-small">
              <a class="has-text-grey is-size-6 is-uppercase" @click="openQuickView">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
                <span>Ajouter une Entrée</span>
              </a>
            </div>
          </div>
          <div
            class="stat-header stat-header--sticky is-border-right is-border-left has-bg-white"
            style="padding-left: 0"
            :style="stickyStyles"
          >
            <div class="columns is-gapless is-size-6-touch is-size-6-desktop is-size-5-widescreen">
              <div class="column is-2 is-border-right"></div>
              <div class="column is-2 has-text-centered is-border-right"><br>Total</div>
              <div class="column is-2 has-text-centered is-border-right"><br>Effectués</div>
              <div class="column is-1 has-text-centered is-border-right"><br>Annulés</div>
              <div class="column is-one-fifth has-text-centered is-border-right"><br>Taux transformation</div>
              <div class="column is-2 has-text-centered">
                <span :data-tooltip="'du ' + futureStartDate + ' au ' + futureEndDate" class="tooltip is-tootltip-primary ">
                  <br>A venir
                </span>
              </div>
              <div
                class="column is-narrow has-text-centered actions is-padding-right-xsmall is-padding-left-xsmall is-paddingless-top is-paddingless-bottom">
                <button class="button is-circle is-small is-invisible">
                  <i class="fal fa-bars"></i>
                </button>
              </div>
            </div>

            <div class="columns is-gapless is-size-6-touch is-size-6-desktop is-size-5-widescreen">
              <div class="columns column is-2 is-vcentered is-border-right">
                <div class="column is-paddingless-right is-padding-top is-padding-bottom is-padding-left-small">
                  <a>
                    <span>Entité</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
              </div>

              <div class="columns column is-2 is-border-right">
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R0</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-down"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R1</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R2</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R3</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
              </div>

              <div class="columns column is-2 is-border-right">
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R0</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-down"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R1</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R2</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R3</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
              </div>


              <div class="columns column is-1 is-border-right">
                <div class="column is-paddingless-right is-paddingless-left has-text-centered">
                  <a>
                    <span>RDV</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
              </div>

              <div class="columns column is-one-fifth is-border-right">
                <div class="column is-4 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R0-R1</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-down"></i></span> -->
                  </a>
                </div>
                <div class="column is-4 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R1-R2</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort"></i></span> -->
                  </a>
                </div>
                <div class="column is-4 is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R2-R3</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
              </div>

              <div class="columns column is-2">
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R0</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-down"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R1</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R2</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
                <div class="column is-3 is-paddingless-right is-padding-left-small">
                  <a>
                    <span>R3</span>
                    <!-- <span class="icon is-pulled-right"><i class="fas fa-sort-up"></i></span> -->
                  </a>
                </div>
              </div>

              <div
                class="column is-narrow has-text-centered actions is-padding-right-xsmall is-padding-left-xsmall is-padding-top-small is-padding-bottom-small">
                <button class="button is-circle is-small is-invisible">
                  <i class="fal fa-bars"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="stat-lignes is-size-6-touch is-size-6-desktop is-size-5-widescreen">
            <rdv-entity-row v-for="e in orderedEntities" :entity="e" v-if="e._stats && e._stats.rdvs"
                            :is-open="currentEntity && currentEntity.pk === e.pk"
                            class="has-bg-white is-border is-relative is-margin-bottom-small"
                            :key="e.pk" @remove="removeEntity" @open="selectEntity" @setColor="updateEntityColor">
            </rdv-entity-row>
            <rdv-entity-row :entity="totalRow" v-if="totalRow" :is-open="false" :is-total="true"
                            :can-be-remove="false" class="is-dark-blue stat-ligne--synthese">
            </rdv-entity-row>
            <div class="lignes-stat is-size-5-widescreen is-size-6-desktop is-size-6-touch is-margin-top-small">
              <div @click="openQuickView"
                   class="add-origine is-border columns is-border-dashed is-radius-large bloc-add">
                <div class="column is-uppercase">Ajouter un utilisateur</div>
                <div class="column is-narrow">
                  <span class="">
                    <i class="fal fa-plus-square"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentTab === TAB_MODES.CHART" class="column is-border-bottom">
          <stats-charts v-if="entities && !loading"
                        :entities="entities"
                        :entity-key="'rdvs'"
                        :chart-name="'rdvChart'"></stats-charts>
          <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { StatsMx, StatsPeriodMx, StatsStickyMx } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'
  import randomColor from 'randomcolor'
  import parallel from 'async/parallel'
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import { findIndex, sortBy, isNil, uniqBy, debounce } from 'lodash'
  import RdvEntityRow from './RdvEntityRow'
  import DatePickerTooltip from '../../utils/DatePickerTooltip'
  import StatsMenu from '../StatsMenu'

  const TAB_MODES = Object.freeze({
    TABLE: 'TABLE',
    CHART: 'CHART'
  })

  export default {
    name: 'RdvsStats',
    mixins: [StatsMx, StatsPeriodMx, StatsStickyMx],
    components: {
      Datepicker,
      RdvEntityRow,
      DatePickerTooltip,
      StatsMenu
    },
    props: {},
    data () {
      return {
        TAB_MODES: TAB_MODES,
        currentTab: TAB_MODES.TABLE,
        sortBy: null,
        sortOrder: 'desc',
        datePickerTooltip: false,
        entities: [],
        data: {},
        currentEntity: null,
        sellers: [],
        poles: [],
        companies: [],
        loadedEntities: 0,
        loading: false,
        userSelections: [],
        userSelectionsEntities: [],
        fullscreen: false
      }
    },
    computed: {
      ...mapState(['currentUser', 'quickview']),
      ...mapGetters(['currentUserPk']),
      futureStartDate () {
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        return endDate.clone().format('DD/MM/YYYY')
      },
      futureEndDate () {
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        return endDate.clone().add(1, 'years').format('DD/MM/YYYY')
      },
      localStorageKey () {
        return this.currentUserPk + '-rdv-stats'
      },
      totalRow () {
        if (this.userSelectionsEntities.length === 0) {
          return null
        }
        let row = {
          name: 'SYNTHÈSE',
          _stats: {
            rdvs: null,
            previousRdvs: null,
            futuresRdvs: null
          }
        }
        let rdvs = []
        let previousRdvs = []
        let futuresRdvs = []
        // let added = []
        // this.userSelectionsEntities.forEach((x) => {
        //   rdvs = rdvs.concat(x._rdvs)
        //   previousRdvs = previousRdvs.concat(x._previousRdvs)
        //   futuresRdvs = futuresRdvs.concat(x._futuresRdvs)
        // })

        for (let entity of this.userSelectionsEntities) {
          rdvs = rdvs.concat(entity._rdvs)
          previousRdvs = previousRdvs.concat(entity._previousRdvs)
          futuresRdvs = futuresRdvs.concat(entity._futuresRdvs)
        }

        rdvs = uniqBy(rdvs, 'pk')

        row._stats.rdvs = this.computedRdvsData(rdvs)
        row._stats.previousRdvs = this.computedRdvsData(previousRdvs)
        row._stats.futuresRdvs = this.computedRdvsData(futuresRdvs)
        return row
      },
      disabledDates () {
        return {
          to: this.rawStartDate
        }
      },
      orderedEntities () {
        let currentEntities = this.userSelectionsEntities
        if (this.sortBy) {
          let entities = sortBy(currentEntities, (x) => {
            if (this.sortBy in x) {
              return x[this.sortBy]
            } else if ('data' in x && !isNil(x.data) && this.sortBy in x.data) {
              return x.data[this.sortBy]
            }
          })
          if (this.sortOrder === 'asc') {
            return entities
          } else {
            return entities.reverse()
          }
        } else {
          return currentEntities
        }
      },
      entitiesPk () {
        return this.userSelectionsEntities.map(x => {
          return x.pk
        })
      }
    },
    watch: {
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            this.addEntities(results.entities)
          }
        }
      }
    },
    methods: {
      changeTab (tab) {
        this.currentTab = tab
      },
      selectEntity (entity) {
        if (this.currentEntity && this.currentEntity.pk === entity.pk) {
          this.currentEntity = null
        } else {
          this.currentEntity = entity
        }
      },
      sort (sortBy) {
        if (this.sortBy !== sortBy) {
          this.sortOrder = 'asc'
        } else {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        }
        this.sortBy = sortBy
      },
      addEntities (entities) {
        let selection = this.userSelections
        entities.forEach(entity => {
          selection.push({ pk: entity.pk, key: entity.key })
        })
        this.userSelections = Array.from(new Set(selection))
        this.saveUserSelections()
      },
      removeEntity (entity) {
        let index = findIndex(this.userSelections, x => {
          return x.pk === entity.pk
        })
        if (index >= 0) {
          this.userSelections.splice(index, 1)
        }
        this.saveUserSelections()
      },
      updateStartDate (dates) {
        console.log('updateStartDate')
        let startDate = moment(dates[0])
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        if (startDate.isAfter(endDate)) {
          this.rawEndDate = startDate.endOf('month').toDate()
        }
        this.updateData()
      },
      updateEndDate (_) {
        console.log('updateEndDate')
        this.updateData()
      },
      createColor (seed) {
        return randomColor({
          seed
        })
      },
      updateData: debounce(function () {
        this.reloadRdvData()
      }, 300),
      reloadRdvData () {
        console.log('reloadRdvData...')
        this.loading = true
        let callbacks = []

        const key = 'USER'

        let startDate = moment(this.rawStartDate, 'YYYY-MM-DD')
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        let delta = endDate.diff(startDate, 'days')
        let previousStartDate = startDate.clone().subtract(delta, 'days')
        let previousEndDate = endDate.clone().subtract(delta, 'days')

        let addSellerEntity = function (dest, seller) {
          dest[seller.pk] = Object.assign({}, seller)
          dest[seller.pk]._stats = {
            rdvs: null,
            previousRdvs: null,
            futuresRdvs: null
          }
        }

        this.userSelectionsEntities.forEach(x => {
          this.$set(x, '_stats', {})
          this.$set(x._stats, 'rdvs', null)
          this.$set(x._stats, 'previousRdvs', null)
          this.$set(x._stats, 'futuresRdvs', null)
          this.$set(x, '_sellers', {})

          let fn1 = (callback) => {
            let params = {
              key,
              pk: x.pk,
              start_date: startDate.format('DD/MM/YYYY'),
              end_date: endDate.format('DD/MM/YYYY'),
              previous_start_date: previousStartDate.format('DD/MM/YYYY'),
              previous_end_date: previousEndDate.format('DD/MM/YYYY')
            }
            console.log('1 params > ', params)
            this.$api.statisticService.getRdvData(params).then(res => {
              let data = this.computedRdvsData(res.data.rdvs)
              let previousData = this.computedRdvsData(res.data.previous_rdvs)
              this.$set(x, '_rdvs', res.data.rdvs)
              this.$set(x, '_previousRdvs', res.data.previous_rdvs)
              this.$set(x._stats, 'rdvs', data)
              this.$set(x._stats, 'previousRdvs', previousData)

              if ('sellers' in res.data) {
                Object.values(res.data.sellers).forEach(s => {
                  let pk = s.seller.pk
                  if ((pk in x._sellers) === false) {
                    addSellerEntity(x._sellers, s.seller)
                  }
                  x._sellers[pk]._stats.rdvs = this.computedRdvsData(s.rdvs)
                })
              }
              callback(null, res.data)
            })
          }
          callbacks.push(fn1)

          let fn2 = (callback) => {
            let params = {
              key,
              pk: x.pk,
              start_date: endDate.clone().format('DD/MM/YYYY'),
              end_date: endDate.clone().add(1, 'years').format('DD/MM/YYYY')
            }
            console.log('2 params > ', params)
            this.$api.statisticService.getRdvData(params)
              .then(res => {
                this.$set(x, '_futuresRdvs', res.data.rdvs)
                let futureData = this.computedRdvsData(res.data.rdvs)
                this.$set(x._stats, 'futuresRdvs', futureData)
                if ('sellers' in res.data) {
                  Object.values(res.data.sellers).forEach(s => {
                    let pk = s.seller.pk
                    if ((pk in x._sellers) === false) {
                      addSellerEntity(x._sellers, s.seller)
                    }
                    x._sellers[pk]._stats.futuresRdvs = this.computedRdvsData(s.rdvs)
                  })
                }
                callback(null, res.data)
              })
          }

          callbacks.push(fn2)
        })

        parallel(callbacks, (err, res) => {
          if (err) {
            console.log(err)
          }
          this.loading = false
        })
      },
      updateEntityData (entity, rawData) {
        console.log('updateEntityData !!!')
        let data = this.computedRdvsData(rawData.rdvs)
        let previousData = this.computedRdvsData(rawData.previous_rdvs)
        if ('sellers' in rawData && rawData.sellers) {
          data.sellers = Object.values(rawData.sellers)
          data.sellers.forEach(x => {
            x.rdvs = this.computedRdvsData(x.rdvs)
          })
        } else {
          data.sellers = []
        }

        let target = this.userSelections.find(x => {
          return x.pk === entity.pk
        })
        this.$set(target, '_rdvs', rawData.rdvs)
        this.$set(target, '_previousRdvs', rawData.previous_rdvs)
        this.$set(target, 'data', data)
        this.$set(target, 'previousData', previousData)
      },
      openQuickView () {
        let params = {
          facets: {
            'USER': ['is_external:False', 'is_editor:False']
          },
          mode: 'append',
          excludes: this.entitiesPk
        }
        this.$store.commit('setQuickview', { mode: 'SELLER_SELECTION', params })
      },
      closeQuickView () {
        this.$store.commit('setQuickview', {})
      },
      openStartMonthPicker () {
        this.$refs.startDatePicker.showCalendar()
      },
      openEndMonthPicker () {
        this.$refs.endDatePicker.showCalendar()
      },
      updateEntityColor (entity, color) {
        this.$set(entity, '_color', color)
        this.saveUserSelections()
      },
      loadUserSelections () {
        this.$api.currentUserService.getOne().then(res => {
          let data = res.data
          if ('app_preferences' in data && 'rdvs_stats_selections' in data.app_preferences) {
            this.userSelections = data.app_preferences.rdvs_stats_selections
          }
          this.loadUserSelectionsData()
        })
      },
      saveUserSelections () {
        let data = Object.assign({}, this.currentUser.app_preferences)
        data['rdvs_stats_selections'] = this.userSelections
        this.$api.userService.patch(this.currentUserPk, { app_preferences: data }).then(() => {
          this.loadUserSelections()
        })
      },
      cleanSelection () {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer la sélection ?',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            let data = Object.assign({}, this.currentUser.app_preferences)
            data['rdvs_stats_selections'] = []
            this.$api.userService.patch(this.currentUserPk, { app_preferences: data }).then(() => {
              this.$set(this, 'userSelections', [])
              this.$nextTick(() => {
                this.loadUserSelections()
              })
            })
          }
        })
      },
      async loadUserSelectionsData () {
        let entities = []
        let usersPk = this.userSelections.filter(x => x.key === 'USER').map(x => x.pk)
        if (usersPk.length > 0) {
          let userRes = await this.$api.userService.get({ pk: usersPk })
          let users = userRes.data.items.map(x => {
            let y = Object.assign({}, x)
            y.key = 'USER'
            return y
          })
          entities = entities.concat(users)
        }
        this.userSelectionsEntities = entities
        this.updateData()
      },
      toggleFullscreen () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('body').classList.add('has-contentmain-fullscreen')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen-leave')
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('body').classList.add('has-contentmain-fullscreen-leave')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen')
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      }
    },
    created () {
      this.initPeriods()
      this.rawStartDate = moment().startOf('year').toDate()
      this.rawEndDate = moment().endOf('month').toDate()
      this.loadUserSelections()
    }
  }
</script>

<style>
  #startDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }

  #endDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/rdv/RdvStats.vue